import { FILE_UPLOAD } from './constants';

export function withUpload(source: string = 'mediaId', key: string = 'file') {
  return { [FILE_UPLOAD]: { key, source } };
}
